import React from 'react';

import fetch from './../fetch';

import utils from './../../utils';

import { Tag } from 'antd';

const prefixUrL = 'assessment/evaluation/year/'

const headers = utils.columns([
    { type: 'selection' },
    {
        key: '$index',
        label: '序号'
    },
    {
        key: 'employeeName',
        label: '教师姓名'
    },
    {
        key: 'employeeCode',
        label: '教师工号'
    },
    {
        key: 'orgName',
        label: '部门名称'
    },
    {
        key: 'finalScore',
        label: '多方测评分',
        width: 100
    },
    {
        key: 'extraPoint',
        label: '附加分',
        width: 100
    },
    {
        key: 'totalScore',
        label: '最终分数',
        width: 100
    },
    // {
    //     key: 'evalExtValue',
    //     label: '考核选项',
    //     render: (val) => {
    //         return val
    //     }
    // },
    // {
    //     key: 'auditState',
    //     label: '审核状态',
    // },
    {
        key: 'resultState',
        label: '提交状态',
        render : (val)=> {
            if(val == '已提交'){
                return <Tag color='green'>{val}</Tag>
            }else if(val == '未提交'){
                return <Tag color='red'>{val}</Tag>
            }
        }
    },
    {
        key: 'termName',
        label: '学期'
    }

]);

const columnsArray = [
    { type: 'selection' },
    {
        key: '$index',
        label: '序号'
    },
    {
        key: 'employeeName',
        label: '教师姓名'
    },
    {
        key: 'employeeCode',
        label: '教师工号'
    },
    {
        key: 'orgName',
        label: '部门名称'
    },
    {
        key: 'finalScore',
        label: '多方测评分',
        width: 100
    },
    {
        key: 'extraPoint',
        label: '附加分',
        width: 100
    },
    {
        key: 'totalScore',
        label: '最终分数',
        width: 100
    },
    // {
    //     key: 'evalExtValue',
    //     label: '考核选项',
    //     render: (val) => {
    //         return val
    //     }
    // },
    // {
    //     key: 'auditState',
    //     label: '审核状态',
    // },
    {
        key: 'resultState',
        label: '提交状态',
        render : (val)=> {
            if(val == '已提交'){
                return <Tag color='green'>{val}</Tag>
            }else if(val == '未提交'){
                return <Tag color='red'>{val}</Tag>
            }
        }
    },
    {
        key: 'termName',
        label: '学期'
    }


];


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post(`${prefixUrL}query?` + params.join('&'), keywords)
        .then(response => {
            let extParams = response.payload.meta.extParams;
            let newArray = []
            for (let i = 0; i < columnsArray.length; i++) {
                if (i === 8) {
                    (extParams.paramOptions || []).map((item) => {
                        newArray.push({
                            key: `${item.optionContent}`,
                            label: `${item.optionContent}`,
                            width: 100,
                            render: (val, row) => {
                                let optionList = row.optionList
                                if(optionList){
                                    optionList.map(o => {
                                        if(o.optionContent === item.optionContent && o.optionType === item.optionType){
                                           val = o.optionValue
                                        }
                                    })
                                }
                                return <div>{val}</div>
                            }
                        })
                    })
                }
                newArray.push(columnsArray[i])
            }
            return {
                data: response.payload.data,
                headers: utils.columns(newArray.length > 0 ? newArray : headers)
            }
        })
        .then(data => (Object.assign({
            headers: data.headers,
            result: data.data.dataList || [],
            selects: (data.data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: data.data.total,
            pageIndex: data.data.pageNum,
            pageSize: data.data.pageSize,
            notify: (data.data.dataList || []).length ? '' : '暂无数据...'
        })));
}

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {

};


export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    getSelection,
    redirect
}